












































































import { Component, Prop, Vue } from "vue-property-decorator";
import CheckboxGroupBoolean from "../CheckboxGroupBoolean.vue";
import CheckboxGroupSlug from "../CheckboxGroupSlug.vue";
import ScoreBlockCard from "../ScoreBlockCard.vue";
import BarthelIndexInput from "../BarthelIndexInput.vue";
import {
  INTERVENSI_GROUPS,
  MASALAH_ITEMS,
  SINDROM_ITEMS
} from "@/constants/geriatriOptions";
import { AsesmenGeriatriContent, BARTHEL_KEYS } from "@/types/asesmen_geriatri";
import { barthelColor, barthelKategori, barthelTotal } from "@/utils/geriatriScore";

@Component({
  components: { CheckboxGroupBoolean, CheckboxGroupSlug, ScoreBlockCard, BarthelIndexInput }
})
export default class SectionMasalahIntervensi extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: AsesmenGeriatriContent;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  masalahItems = MASALAH_ITEMS;
  sindromItems = SINDROM_ITEMS;
  intervensiGroups = INTERVENSI_GROUPS;

  get barthelAwalTotal(): number {
    return barthelTotal(this.value.skrining.status_fungsional.barthel_awal);
  }
  get barthelAkhirTotal(): number {
    return barthelTotal(this.value.skrining.status_fungsional.barthel_akhir);
  }
  get barthelAkhirKategori(): string {
    return barthelKategori(this.barthelAkhirTotal);
  }
  get barthelAkhirColor(): string {
    return barthelColor(this.barthelAkhirTotal);
  }

  get delta(): number | null {
    const awal = this.value.skrining.status_fungsional.barthel_awal as any;
    const akhir = this.value.skrining.status_fungsional.barthel_akhir as any;
    const adaAwal = BARTHEL_KEYS.some(k => awal[k] !== null && awal[k] !== "");
    const adaAkhir = BARTHEL_KEYS.some(k => akhir[k] !== null && akhir[k] !== "");
    return adaAwal && adaAkhir ? this.barthelAkhirTotal - this.barthelAwalTotal : null;
  }

  get deltaColor(): string {
    if (this.delta === null || this.delta === 0) return "grey";
    return this.delta > 0 ? "green" : "red";
  }
}
